import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { container } from '@Container';
import { TYPES } from '@Types';
import { BooksAction, ArmyBooksAction } from '@Redux/actions';
import MyBooksComponent from '@Components/publication/my-books/my-books.component';
import BooksActionComponent from '@Components/publication/books-action/books-action.component';
import BookNewComponent from '@Components/publication/book-new/book-new.component';
import { getMyBoardState } from '@Selectors/builder/myBuilder/selector/getMyBoardState';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';
import MyArmyBooksComponent from '@Components/publication/army/my-army-books.component';

const PublicationBookPageIndex: React.FC<PublicationBookPageMakeProps> = ({ create, load }) => {
  React.useEffect(() => {
    load();
  }, []);

  return (
    <>
      <BooksActionComponent />
      {create && <BookNewComponent />}
      <MyArmyBooksComponent />
      <MyBooksComponent />
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  create: getMyBoardState(state).entity === MyBuilderActionState.BookCreation,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BooksAction>(TYPES.Actions.Publication.BooksAction);
  const armyAction = container.get<ArmyBooksAction>(TYPES.Actions.Publication.ArmyBooksAction);

  return {
    load: () => {
      dispatch(action.fetchData())
      dispatch(armyAction.fetchData())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationBookPageIndex);

type PublicationBookPageMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
